import { useState } from "react";
import { Bell, ShieldCheck, Wallet, CandlestickChart, AlertTriangle, BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Empty } from "@/components/kit";
import { AlertsList } from "@/components/PriceAlerts";

const ICONS = { info: Bell, security: ShieldCheck, finance: Wallet, trade: CandlestickChart, warning: AlertTriangle, alert: BellRing };

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/me/notifications").then((r) => setRows(r.data));
  usePoll(() => load().catch(() => {}), 15000);
  const read = async (id) => { await api.post(`/me/notifications/${id}/read`); load(); window.dispatchEvent(new Event("tr:notifications")); };
  const readAll = async () => { await api.post("/me/notifications/read-all"); load(); window.dispatchEvent(new Event("tr:notifications")); };
  return (
    <div data-testid="notifications-page">
      <PageHeader eyebrow="Avisos" title="Notificações" desc="Avisos importantes da plataforma, confirmações de operações e alertas de segurança."
        actions={<Button variant="outline" onClick={readAll} data-testid="mark-all-read-btn">Marcar todas como lidas</Button>} />
      <div className="surface p-5 md:p-6 mb-6" data-testid="my-alerts-card">
        <div className="eyebrow mb-2 flex items-center gap-1.5"><BellRing className="h-3.5 w-3.5 text-primary" />Meus alertas de preço</div>
        <p className="text-xs text-muted-foreground mb-2">Crie alertas no Painel (sino ao lado dos favoritos) ou na página de negociação do ativo.</p>
        <AlertsList />
      </div>
      <div className="surface divide-y divide-border">
        {rows.length === 0 && <Empty text="Nenhuma notificação." />}
        {rows.map((n) => {
          const Icon = ICONS[n.kind] || Bell;
          return (
            <div key={n.id} className={`flex gap-4 p-5 ${n.read ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
              <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-muted"><Icon className="h-5 w-5 text-primary" /></div>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2"><span className="font-semibold">{n.title}</span>
                  {n.user_id === "all" && <span className="rounded-full bg-primary/15 px-2 text-[10px] font-bold text-primary">COMUNICADO</span>}
                  {!n.read && <span className="h-2 w-2 rounded-full bg-primary" />}</div>
                <p className="mt-1 text-sm text-muted-foreground">{n.body}</p>
                <p className="mt-1 text-xs text-muted-foreground">{fmtDateTime(n.created_at)}</p>
              </div>
              {!n.read && <Button size="sm" variant="ghost" onClick={() => read(n.id)} data-testid={`mark-read-${n.id}`}>Marcar como lida</Button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
